import { useEffect, useState } from 'react';
import _ from 'lodash';

const useCheckTeams = () => {
  const [checkedTeams, setCheckedTeams] = useState([]);
  const [total, setTotal] = useState({ teams: 0, contributors: 0 });
  const [isCalculatingTotal, setIsCalculatingTotal] = useState(false);

  const checkTeam = team => {
    const childrenIds = getAllChidrenTeamIds(team);
    const teamsWithoutChilds = checkedTeams.filter(
      _team => !childrenIds[_team.id]
    );
    setCheckedTeams([...teamsWithoutChilds, team]);
  };
  const unCheckTeam = team =>
    setCheckedTeams(teams => teams.filter(_team => _team.id !== team.id));
  const isTeamChecked = team =>
    checkedTeams.map(_team => _team.id).includes(team.id);
  const isTeamChildChecked = team =>
    _.intersection(
      checkedTeams.map(_team => _team.id),
      _.keys(getAllChidrenTeamIds(team))
    ).length > 0;

  const toggleTeamCheckbox = team =>
    isTeamChecked(team) ? unCheckTeam(team) : checkTeam(team);

  const getAllChidrenTeamIds = team => {
    const teamChildren = _.get(team, 'children', []);
    return teamChildren.reduce(
      (acc, teamChild) => ({
        ...acc,
        ...getAllChidrenTeamIds(teamChild),
        [teamChild.id]: teamChild
      }),
      {}
    );
  };

  const calculateTotalTeamsAndContributors = () => {
    setIsCalculatingTotal(true);
    const allSelectedTeamsKeys = checkedTeams.reduce(
      (acc, team) => ({
        ...acc,
        ...getAllChidrenTeamIds(team),
        [team.id]: team
      }),
      {}
    );
    const totalTeams = _.size(allSelectedTeamsKeys);

    const allContributorsIds = Object.keys(allSelectedTeamsKeys).reduce(
      (acc, key) => {
        const team = allSelectedTeamsKeys[key];
        const teamMembers = _.get(team, 'members', []);
        return [...acc, ...teamMembers.map(member => member.id)];
      },
      []
    );
    const distinctContributorsIds = _.uniq(allContributorsIds);
    const totalContributors = _.size(distinctContributorsIds);

    setTotal({ teams: totalTeams, contributors: totalContributors });
    setIsCalculatingTotal(false);
  };

  useEffect(() => {
    calculateTotalTeamsAndContributors();
  }, [_.get(checkedTeams, '[0].id'), checkedTeams.length]);
  return {
    checkedTeams,
    isTeamChecked,
    isTeamChildChecked,
    toggleTeamCheckbox,
    setCheckedTeams,
    total,
    isCalculatingTotal
  };
};

export default useCheckTeams;
